import { SIGNAL_MISSING_CODE } from './types';

/**
 * 서버가 대상 공종의 신호 3줄을 찾지 못했을 때(HTTP 503 SIGNAL_MISSING)의 오류.
 * 빈 신호는 장애다 — 폴백(PARTNER_STATUS 등)으로 덮지 않고 화면이 오류 상태로 보여준다(신호_이후_구현지시서 1장 8).
 */
export class SignalMissingError extends Error {
  readonly code = SIGNAL_MISSING_CODE;
  readonly missingTaskIds: number[];

  constructor(message: string, missingTaskIds: number[]) {
    super(message);
    this.name = 'SignalMissingError';
    this.missingTaskIds = missingTaskIds;
  }
}

interface ErrorBody {
  code?: unknown;
  message?: unknown;
  data?: { missingTaskIds?: unknown } | null;
}

/** axios 오류의 응답 본문이 SIGNAL_MISSING 이면 SignalMissingError 로, 아니면 원래 오류 그대로 돌려준다. */
export function toSignalError(e: unknown): unknown {
  const body = (e as { response?: { data?: ErrorBody } } | null)?.response?.data;
  if (body && body.code === SIGNAL_MISSING_CODE) {
    const ids = Array.isArray(body.data?.missingTaskIds) ? (body.data?.missingTaskIds as unknown[]).filter((v): v is number => typeof v === 'number') : [];
    return new SignalMissingError(typeof body.message === 'string' ? body.message : '신호 정보를 불러오지 못했어요', ids);
  }
  return e;
}
